import { createSelector } from '@ngrx/store';

import { venueImagesState } from '../root';

export const getAllVenueImages = createSelector(venueImagesState, (venuesImages) => venuesImages);
